import React from "react";

const Suspend = React.lazy(() => new Promise(() => <></>));

const Suspender: React.FC<{ suspend: boolean }> = (props) =>
  props.suspend ? <Suspend /> : <>{props.children}</>;

export default Suspender;
